import React from 'react';

import { formatCurrency } from '~libs/dataUtils';

interface Budget {
  amount: string;
  budgetTypeCode: string;
  budgetTypeText: string;
}

interface FundingSource {
  id: number;
  name: string;
  sah_code?: string;
}

interface ComponentProps {
  meta_budgets?: Budget[];
  funding_sources?: FundingSource[];
}

const FundingSourceBadges: React.FC<ComponentProps> = ({ meta_budgets, funding_sources }) => {
  if (!meta_budgets || meta_budgets.length === 0) {
    return <span className="funding-source-badges empty">-</span>;
  }

  // Create a map of funding sources by sah_code for quick lookup
  const fundingSourceMap = new Map<string, FundingSource>();
  funding_sources?.forEach((source) => {
    if (source.sah_code) {
      fundingSourceMap.set(source.sah_code, source);
    }
  });

  return (
    <div className="funding-source-badges">
      {meta_budgets.map((budget, index) => {
        const fundingSource = fundingSourceMap.get(budget.budgetTypeCode);
        const displayName = fundingSource?.name || budget.budgetTypeText;

        return (
          <span key={index} className={`badge ${(budget.budgetTypeCode || 'unknown').toLowerCase()}`}>
            {displayName}: {formatCurrency(Math.abs(parseFloat(budget.amount)))}
          </span>
        );
      })}
    </div>
  );
};

export default FundingSourceBadges;
